import styled from '@emotion/styled'
import { isMobile } from '@const/device'
import Title from '@organisms/Title'

const DesktopWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  gap: 15px;
  margin-right: 5px;
  background-color: white;
  border-radius: 50px;
  padding: 0 15px;
`
const MobileWrapper = styled(DesktopWrapper)``
export const Wrapper = isMobile ? MobileWrapper : DesktopWrapper

export const StyledTitle = styled(Title)`
  margin: 0;
`
